import { render, staticRenderFns } from "./ListOrders.vue?vue&type=template&id=0e13e4d8&"
import script from "./ListOrders.vue?vue&type=script&lang=js&"
export * from "./ListOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports